<template>
  <div class="h-box">
    <h2 class="global-title">{{ $t('mbs-select-mfa') }}</h2>
    <div class="login-box-help">
      <img src="~img/help.png" alt="help" v-if="!showTips" @click="showTips = !showTips" />
      <div class="login-box-close" v-if="showTips">
        <img src="~img/close.png" alt="close" @click="showTips = !showTips" />
      </div>
      <div class="login-help" v-if="showTips">
        <h2>{{ $i18n.t('tips-title') }}</h2>
        <p v-for="(item, index) in tipsConfig" :key="index">
          <span>{{ item.title }}</span>
          <br />
          <span>
            {{ item.description }}
          </span>
        </p>
      </div>
    </div>
    <div class="mfa-info">
      <p class="h-txt" v-if="!isVerifying">
        <span v-if="isVerified">{{ $i18n.t('mfa-switcher-desc2') }}</span>
        <span v-else>{{ $i18n.t('mfa-switcher-desc1') }}</span>
        <Switcher :value="mfaStatus" @change="handleMfaChange" v-if="isVerified"></Switcher>
      </p>

      <ul class="h-info-box" v-if="!isVerifying">
        <li class="h-content">
          <img src="@/components/LeftAccount/images/icon-phone.svg" alt="phone" />
          <div class="h-info">
            <p class="h-info-status pass" v-if="isPhoneVerified">
              {{ $i18n.t('mfa-switcher-verified-mobile') }}
            </p>
            <p class="h-info-status err" v-else>{{ $i18n.t('mfa-switcher-unverified-mobile') }}</p>
            <p class="h-info-type">{{ desensitizedPhone }}</p>
          </div>
          <button class="h-button" @click="handeVerify(2)" v-if="!isPhoneVerified">
            {{ $i18n.t('mfa-switcher-verify-btn') }}
          </button>
          <img src="@/components/LeftAccount/images/icon-verifyed.svg" alt="verifyed" v-else />
        </li>
        <li class="h-content">
          <img src="@/components/LeftAccount/images/icon-email.svg" alt="email" />
          <div class="h-info">
            <p class="h-info-status pass" v-if="isEmailVerified">
              {{ $i18n.t('mfa-switcher-verified-email') }}
            </p>
            <p class="h-info-status err" v-else>{{ $i18n.t('mfa-switcher-unverified-email') }}</p>
            <p class="h-info-type">{{ desensitizedEmail }}</p>
          </div>
          <button class="h-button" @click="handeVerify(1)" v-if="!isEmailVerified">
            {{ $i18n.t('mfa-switcher-verify-btn') }}
          </button>
          <img src="@/components/LeftAccount/images/icon-verifyed.svg" alt="verifyed" v-else />
        </li>
      </ul>
    </div>
    <Captcha
      v-if="isVerifying"
      @handleResend="handleResend"
      @handleDone="handleDone"
      @handleFinish="handleFinish"
      :loading="loading"
      :bottomline="false"
      :errMsg="errMsg"
    >
      <template #title>
        <img src="~img/icon-lock-black.svg" alt="lock" />
        <span>{{ $i18n.t('code-auth-title') }}</span>
      </template>
      <template #desc>{{ $i18n.t('code-auth-desc1') }}</template>
      <template #info>{{ captchaInfo }}</template>
    </Captcha>
  </div>
</template>
<script>
  import Captcha from '../../../Login/Captcha.vue';
  import Switcher from '@/components/BaseUi/Switch/index.vue';
  import { /* mapMutations, */ mapState } from 'vuex';
  import { getEmailBeforeAt, getFirst4andLast2Num } from '@/utils';
  import store from '@/store';

  export default {
    name: 'MFA',
    components: { Captcha, Switcher },
    data() {
      return {
        showTips: false,
        loginDisable: true,
        loading: false,
        isVerifying: false,
        mfaStatus: false,
        /* mfaDetail: {
          callPrefix: '',
          phone: '',
          email: '',
        }, */
        authType: 1, // 1-邮件 2-手机
        errMsg: '',
      };
    },
    computed: {
      tipsConfig() {
        return [
          {
            title: this.$i18n.t('mfa-helptext-title-1'),
            description: this.$i18n.t('mfa-helptext-desc-1'),
          },
          {
            title: this.$i18n.t('mfa-helptext-title-2'),
            description: this.$i18n.t('mfa-helptext-desc-2'),
          },
          {
            title: this.$i18n.t('mfa-helptext-title-3'),
            description: this.$i18n.t('mfa-helptext-desc-3'),
          },
          {
            title: this.$i18n.t('mfa-helptext-title-4'),
            description: this.$i18n.t('mfa-helptext-desc-4'),
          },
        ];
      },
      isPhoneVerified() {
        return this.mfaDetail.checkInt === 2 || this.mfaDetail.checkInt === 3;
      },
      isEmailVerified() {
        return this.mfaDetail.checkInt === 1 || this.mfaDetail.checkInt === 3;
      },
      isUnverified() {
        return this.mfaDetail.checkInt === 0;
      },
      isVerified() {
        return this.mfaDetail.checkInt === 3;
      },
      desensitizedPhone() {
        const { callPrefix, phone } = this.mfaDetail;
        const phEx = `+${callPrefix}`;
        const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
        return `${phEx} ${getFirst4andLast2Num(newPhone)}`;
      },
      desensitizedEmail() {
        const { email } = this.mfaDetail;
        return getEmailBeforeAt(email);
      },
      captchaInfo() {
        return this.authType === 1 ? this.desensitizedEmail : this.desensitizedPhone;
      },
      ...mapState(['userInfo', 'mfaDetail']),
    },
    mounted() {
      this.getMFAStatus();
    },
    methods: {
      getMFAStatus() {
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          lang: this.$i18n.locale,
          sessionId,
        };
        this.$http.account.getMFAStatus(data).then(res => {
          if (res.state === '11') {
            store.commit('setState', {
              state: 'mfaDetail',
              values: res.payload,
            });
            // this.mfaDetail = res.payload;
            this.mfaStatus = !!res.payload.mfa;
          }
        });
      },
      sendAuthCode(authType, succcessCallback) {
        const { userId, sessionId } = this.userInfo;
        // const { email, callPrefix, phone } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const data = {
          userId,
          sessionId,
          lang: this.$i18n.locale,
          authType,
          userContactToken,
          sendScene: 0, //  0 普通opt 1 修改手机
        };
        this.$http.account.sendAuthCode(data).then(res => {
          if (res.state === '11') {
            // code sent
            this.authType = authType;
            this.authKey = res.payload.key;
            this.isVerifying = true;
            succcessCallback && succcessCallback();
          } else {
            // 错误码处理
            if (res.errorCode === 'retry.after.1.min') {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-4'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
              });
            } else if (res.errorCode === 'error.6.locked.30') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-3'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-5'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.isVerifying = false;
                },
              });
            } else if (res.errorCode === 'too.many.requests') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-2'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-2'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.isVerifying = false;
                },
              });
            }
          }
        });
      },
      handeVerify(authType) {
        this.sendAuthCode(authType);
      },
      handleDone(authCode) {
        if (this.loginDisable) return;
        const { userId, sessionId } = this.userInfo;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const data = {
          userId,
          sessionId,
          lang: this.$i18n.locale,
          authType: this.authType,
          authCode,
          key: this.authKey,
          deviceId: localStorage.getItem('deviceId'),
          userContactToken,
          checkScene: 0,
        };
        this.$http.account
          .checkAuthCode(data)
          .then(res => {
            if (res.state === '11') {
              // code sent
              this.getMFAStatus();
              this.isVerifying = false;
            } else {
              if (res.errorCode === 'opt.code.error') {
                this.errMsg = this.$i18n.t('code-auth-notmatch');
              } else if (res.errorCode === 'error.6.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-1'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.isVerifying = false;
                  },
                });
              } else if (res.errorCode === 'auth.error.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-3'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-5'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.isVerifying = false;
                  },
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      handleResend(callback) {
        console.log('resend');
        this.loginDisable = false;
        this.errMsg = '';
        this.sendAuthCode(this.authType, callback);
      },
      handleFinish(data) {
        console.log('finish', data);
        this.loginDisable = false;
        this.errMsg = '';
      },
      handleMfaChange(value) {
        console.log(value);
        this.mfaStatus = value;
        const { userId, sessionId } = this.userInfo;
        const data = {
          userId,
          sessionId,
          mfa: this.mfaStatus ? 1 : 0,
        };
        this.$http.account.updateMft(data).then(res => {
          if (res.state === '11') {
            // success
          } else {
            this.mfaStatus = !value;
          }
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .h-box {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
    }

    .login-box-help {
      z-index: 99;
      text-align: left;
      // height: 80px;
      margin-bottom: 0px;
      position: relative;

      img {
        position: absolute;
        top: 0px;
        right: 21px;
        width: 31px;
        height: 31px;
      }

      .login-box-close {
        position: absolute;
        box-sizing: border-box;
        top: -25px;
        right: 0;
        width: 73px;
        height: 80px;
        background-color: #163049;
        border-radius: 0px 10px 10px 0px;

        img {
          top: 25px;
          right: 21px;
        }
      }

      .login-help {
        position: absolute;
        width: 500px;
        // height: 700px;
        background-color: #163049;
        right: 73px;
        top: -25px;
        border-radius: 10px 0px 10px 10px;
        color: #ffffff;
        text-align: start;
        padding: 23px 40px;
        box-sizing: border-box;

        h2 {
          margin-bottom: 10px;
          @include font(22px, 700);
          font-size: min(18px);
          line-height: 30px;
        }

        p {
          margin-bottom: 15px;
          line-height: 20px;

          span:first-child {
            @include font(14px, 600);
            font-size: min(14px);
            line-height: 16px;
          }
          span:last-child {
            @include font(14px, 400);
            font-size: min(14px);
            line-height: 16px;
          }
        }
      }
    }
    .mfa-info {
      .h-txt {
        width: 80%;
        // margin-right: 100px;
        @include font(18px, 400);
        color: $color-blue;
        display: flex;
        align-items: flex-start; /* 垂直居中 */

        span {
          width: 90%;
          margin-right: 40px;
          vertical-align: super;
        }
      }

      .h-info-box {
        width: 80%;
        margin-top: 20px;
        .h-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row;
          padding: 20px 10px;
          border-top: #9eacb5 1px solid;
          @include font(16px, 600);

          &:last-child {
            border-bottom: #9eacb5 1px solid;
          }

          img {
            width: 32px;
            height: 32px;
          }

          .h-info {
            flex: 1;
            padding-left: 20px;

            .h-info-status {
              @include font(12px, 600);
              line-height: 20px;

              &.err {
                color: #cb0f22;
              }

              &.pass {
                color: #378523;
              }
            }
            .h-info-type {
              @include font(18px, 600);
            }
          }
          .h-button {
            width: 80px;
            border: 2px solid #cc2222;
            border-radius: 8px;
            padding: 10px;
            color: #cc2222;
            background-color: transparent;
            cursor: pointer;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .h-box {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 12px;
        padding: 0;
      }
      .login-box-help {
        img {
          top: -50px;
        }
        .login-box-close {
          top: -74px;
          width: 60px;
          height: 60px;
          background-color: unset;
          border-radius: unset;
          z-index: 99;
        }

        .login-help {
          overflow: scroll;
          -webkit-overflow-scrolling: touch;
          max-height: 300px;
          width: 80%;
          right: 36px;
          top: -35px;
          color: #ffffff;
          padding: 13px 20px;

          h2 {
            margin-bottom: 10px;
          }

          p {
            margin-bottom: 10px;

            span:first-child {
              @include font(16px, 600);
            }
            span:last-child {
              @include font(16px, 400);
            }
          }
        }
      }
      .mfa-info {
        .h-txt {
          width: 100%;
          @include font(16px, 400);
          line-height: 22px;
          padding-top: 16px;
          margin: 0;
          flex-direction: column;
          align-items: flex-end;

          span {
            width: 100%;
            margin: 0;
          }
        }
        .h-info-box {
          width: 100%;
        }
      }
    }
  }
</style>
